import { Component, OnInit } from '@angular/core';
import { ColumnMode } from "@swimlane/ngx-datatable";
import { IofferFilter, IFilterView, Page } from '../../../../shared/filters/filters';
import { OfferStatus } from '../../../../models/admModel/offer.model';
import { OffersService } from '../../../../shared/services/admServices/offers.service';
import { SharedService } from 'src/app/shared/services/sharedServices/shared.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'adm-over-component',
  templateUrl: './offers-component.html',
  styleUrls: ['./offers-component.scss'],
})

export class campoverviewComponent implements OnInit {

  page = new Page();
  filter : IofferFilter = { pageNumber:1, pageSize:40 };
  filterview : IFilterView = { 
    advertiserOfferIds: false, 
    offerCategories: false,
    offerDevices: false,
    offerAdvertisers: false,
    offerCountries: false
  }; 
  
  status = new OfferStatus();

  btnName: any;
  btnColor: any;
  btnOn: any = false;

  dropdownListCategories : any[] = [];
  selectedItemsCategories : any[] = [];
  dropdownSettingsCategories: any = {};

  dropdownListDevice : any[] = [];
  selectedItemsDevice : any[] = [];
  dropdownSettingsDevice: any = {};

  dropdownListAdvertiser : any[] = [];
  selectedItemsAdvertiser : any[] = [];
  dropdownSettingsAdvertiser: any = {};

  selectedAdvertiserOfferId : string = "";

  selectedItemsCountry : any[] = [];
  dropdownSettingsCountry: any = {};
  countries: any;

  offersData: any;
  offsetNumber: number;
  pageSizeDefinition = 40;
  loading = false;

  ColumnMode = ColumnMode;

  constructor(private offersService: OffersService, private sharedServices: SharedService, private toastrService: ToastrService) {
    this.btnName = "Filter";
    this.btnColor = "btn-info";

    this.offsetNumber = 0;
    this.page.pageNumber = 1;
    this.page.size = this.pageSizeDefinition;
  }

  ngOnInit(): void {
    // dropdownlist TYPE
    this.dropdownListCategories = [
      { item_id: 1, item_text: 'Click' },
      { item_id: 2, item_text: 'Credit Card Submit' },
      { item_id: 3, item_text: 'Download' },
      { item_id: 4, item_text: 'Email/Zip Submit' },
      { item_id: 5, item_text: 'Mobile install' },
      { item_id: 6, item_text: 'PIN Submit' },
      { item_id: 7, item_text: 'Trial' },
      { item_id: 8, item_text: 'WAP Billing' },
      { item_id: 9, item_text: 'Other' }
    ];
    this.dropdownSettingsCategories = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 1,
      allowSearchFilter: false
    };
    // dropdownlist DEVICE
    this.dropdownListDevice = [
      { item_id: 1, item_text: 'Desktop' },
      { item_id: 2, item_text: 'Game console' },
      { item_id: 3, item_text: 'Phone' },
      { item_id: 4, item_text: 'Tablet' },
      { item_id: 5, item_text: 'TV' },
    ];
    this.dropdownSettingsDevice = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      enableCheckAll: false,
      itemsShowLimit: 1,
      allowSearchFilter: false
    };

    // dropdownlist ADVERTISER
    this.dropdownListAdvertiser = [
      { item_id: 1, item_text: 'AdGate' },
      { item_id: 2, item_text: 'Affluent' },
      { item_id: 3, item_text: 'Aragon' },
      { item_id: 4, item_text: 'ClickDealer' },
      { item_id: 5, item_text: 'Mapstreet' },
      { item_id: 6, item_text: 'PocketMedia' },
      { item_id: 7, item_text: 'SmartResponseMedia' },  //
      { item_id: 8, item_text: 'Vanelo' },  //
      { item_id: 9, item_text: 'OpinionSample' },
      { item_id: 10, item_text: 'Wdigital' },
      { item_id: 11, item_text: 'AdstartMedia' },
      { item_id: 12, item_text: 'Mobitka' } //
    ];
    this.dropdownSettingsAdvertiser = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      enableCheckAll: false,
      itemsShowLimit: 1,
      allowSearchFilter: false
    };

    // dropdownlist COUNTRY
    this.getCountries();
    this.dropdownSettingsCountry = {
      singleSelection: false,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true
    };

    this.setSelected();

    if(this.offersService.getFilter(5))
    {
      // filter is ON
      this.btnName = "Filter";
      this.btnColor = "btn-danger";
      this.btnOn = true;
    }

    this.setPage({ offset: this.offersService.getFilter(6) });
  }

  setSelected(){
    // ustawienie pierwszego filtra - categories
    this.selectedItemsCategories = this.offersService.getFilter(1);
    if(this.selectedItemsCategories==null)
    {
      this.selectedItemsCategories = [];
      this.offersService.saveFilter(1, this.selectedItemsCategories);
    }

    // ustawienie drugiego filtra - device
    this.selectedItemsDevice = this.offersService.getFilter(2);
    if(this.selectedItemsDevice==null)
    {
      this.selectedItemsDevice = [];
      this.offersService.saveFilter(2, this.selectedItemsDevice);
    }

    // ustawienie trzeciego filtra - advertiser
    this.selectedItemsAdvertiser = this.offersService.getFilter(3);
    if(this.selectedItemsAdvertiser==null)
    {
      this.selectedItemsAdvertiser = [];
      this.offersService.saveFilter(3, this.selectedItemsAdvertiser);
    }

    this.selectedItemsCountry = this.offersService.getFilter(4);
    if(this.selectedItemsCountry==null)
    {
      this.selectedItemsCountry = [];
      this.offersService.saveFilter(4, this.selectedItemsCountry);
    }

    // ustawienie filtra - advertiser offer id
    this.selectedAdvertiserOfferId = this.offersService.getFilter(7);
    if(this.selectedAdvertiserOfferId==null)
    {
      this.selectedAdvertiserOfferId = "";
      this.offersService.saveFilter(7, this.selectedAdvertiserOfferId);
    }

    this.offsetNumber = 0;// rzeczywisty numer strony jest offsetNumber+1, 0 odpowiada pierwszej stronie

    this.setFilter();
  }

  getCountries(): void {
    this.sharedServices.getAllCountries()
    .subscribe(
     data => {
       this.countries = data.data.countries;
       console.log(data);
     },
     error => {
       console.log(error);
     });
  }

  setPage(pageInfo){
    this.filter.pageNumber = pageInfo.offset+1;
    this.filter.pageSize = this.pageSizeDefinition;
    this.offersService.saveFilter(6, pageInfo.offset);
    this.loading = true;

    console.log("FILTER: ", this.filter);
    // włączony filtr
    this.offersService.getOffers(this.filter)
    .subscribe(
    data => {
      this.page.totalElements = data.totalRecords;
      this.page.totalPages = data.totalPages;
      this.page.pageNumber = data.pageNumber-1;
      this.offersData = data.data;
    },
    error => {
      console.log(error);
    });

    this.loading = false;
  }

  onStatus(req) {

    if(req.status.globalStatus=='Active')
      this.status.statusId=3; // disabled
    else
      this.status.statusId=1; //active

    this.offersService.updateOfferStatus(req.offerId, this.status)
    .subscribe(
     () => {
      this.toastrService.success('Global offer status is changed.', 'Success !');
      this.setPage({ offset: this.offersService.getFilter(6) });
    },
     error => {
       console.log(error);
     });
  }

  setFilter(){
    // filter advertiser offer Id
    delete this.filter.advertiserOfferIds;
    if(this.selectedAdvertiserOfferId.length>0)
    {
      // coś zostało wpisane
      this.filter.advertiserOfferIds = [];
      this.filterview.advertiserOfferIds = true;
      this.filter.advertiserOfferIds[0] = this.selectedAdvertiserOfferId;
      this.offersService.saveFilter(7, this.selectedAdvertiserOfferId);
    }
    else
    {
      this.selectedAdvertiserOfferId = "";
      this.offersService.saveFilter(7, this.selectedAdvertiserOfferId);
      delete this.filter.advertiserOfferIds;
      this.filterview.advertiserOfferIds = false;
    }

    // filter Type
    delete this.filter.offerCategories;
    if(this.selectedItemsCategories.length>0)
      {
        // coś zostało wybrane lub coś jest ustawione
        this.filter.offerCategories= [];
        this.filterview.offerCategories = true;

        for(var i=0; i<this.selectedItemsCategories.length; i++)
          this.filter.offerCategories[i] = this.selectedItemsCategories[i].item_id;
        this.offersService.saveFilter(1, this.selectedItemsCategories);
      }
    else
    {   
      this.selectedItemsCategories = [];
      this.offersService.saveFilter(1, this.selectedItemsCategories);
      delete this.filter.offerCategories;
      this.filterview.offerCategories = false;
    }

    // filter Device
    delete this.filter.offerDevices;
    if(this.selectedItemsDevice.length>0)
    {
      // coś zostało wybrane lub coś jest ustawione
      this.filter.offerDevices = [];
      this.filterview.offerDevices = true;

      for(var i=0; i<this.selectedItemsDevice.length; i++)
        this.filter.offerDevices[i] = this.selectedItemsDevice[i].item_id;
      this.offersService.saveFilter(2, this.selectedItemsDevice);
    }
    else
    {
      this.selectedItemsDevice = [];
      this.offersService.saveFilter(2, this.selectedItemsDevice);
      delete this.filter.offerDevices;
      this.filterview.offerDevices = false;
    }

    // filter Advertiser
    delete this.filter.offerAdvertisers;
    if(this.selectedItemsAdvertiser.length>0)
    {
      // coś zostało wybrane lub coś jest ustawione
      this.filter.offerAdvertisers = [];
      this.filterview.offerAdvertisers = true;

      for(var i=0; i<this.selectedItemsAdvertiser.length; i++)
        this.filter.offerAdvertisers[i] = this.selectedItemsAdvertiser[i].item_id;
      this.offersService.saveFilter(3, this.selectedItemsAdvertiser);
    }
    else
    {
      this.selectedItemsAdvertiser = [];
      this.offersService.saveFilter(3, this.selectedItemsAdvertiser);
      delete this.filter.offerAdvertisers;
      this.filterview.offerAdvertisers = false;
    }

    // filter Countries
    delete this.filter.offerCountries;
    if(this.selectedItemsCountry.length>0)
    {
       // coś zostało wybrane lub coś jest ustawione
      this.filter.offerCountries = [];
      this.filterview.offerCountries = true;

      for(var i=0; i<this.selectedItemsCountry.length; i++)
        this.filter.offerCountries[i] = this.selectedItemsCountry[i].id;
      this.offersService.saveFilter(4, this.selectedItemsCountry);
    }
    else
    {
      this.selectedItemsCountry = [];
      this.offersService.saveFilter(4, this.selectedItemsCountry);
      delete this.filter.offerCountries;
      this.filterview.offerCountries = false;
    }
  }

  onFilter(){
    // filter is ON
    this.btnName = "Filter";
    this.btnColor = "btn-danger";
    this.btnOn = true;
    this.offersService.saveFilter(5, this.btnOn);

    this.setFilter();
    this.setPage({ offset: 0 });
  }

  onClear(){
    // filter is OFF and default parameters are used

    this.btnName = "Filter";
    this.btnColor = "btn-info";
    this.btnOn = false;
    this.offersService.saveFilter(5, this.btnOn);

    this.selectedItemsCategories = [];
    this.offersService.saveFilter(1, this.selectedItemsCategories);
    delete this.filter.offerCategories;
    this.filterview.offerCategories = false;

    this.selectedItemsDevice = [];
    this.offersService.saveFilter(2, this.selectedItemsDevice);
    delete this.filter.offerDevices;
    this.filterview.offerDevices = false;

    this.selectedItemsAdvertiser = [];
    this.offersService.saveFilter(3, this.selectedItemsAdvertiser);
    delete this.filter.offerAdvertisers;
    this.filterview.offerAdvertisers = false;

    this.selectedItemsCountry = [];
    this.offersService.saveFilter(4, this.selectedItemsCountry);
    delete this.filter.offerCountries;
    this.filterview.offerCountries = false;

    this.selectedAdvertiserOfferId = "";
    this.offersService.saveFilter(7, this.selectedAdvertiserOfferId);
    delete this.filter.advertiserOfferIds;
    this.filterview.advertiserOfferIds = false;


    this.filter.pageNumber = 1;
    this.filter.pageSize = this.pageSizeDefinition;

    this.setFilter();
    this.setPage({ offset: 0 });
  }

  onAdverOfferId(event){
    if(this.selectedAdvertiserOfferId.length>0)
    {      
      this.filterview.advertiserOfferIds = true
    }
    else
    {
      this.filterview.advertiserOfferIds = false;
    }
    this.onFilter();
  }

  onItemSelectType(items: any) {
    this.onFilter();
  }

  onItemDeSelectType(items: any) {
    this.onFilter();
  }

  onItemSelectDevice(item: any) {
    this.onFilter();
  }

  onItemDeSelectDevice(items: any) {
    this.onFilter();
  }

  onItemSelectAdvertiser(item: any) {
    this.onFilter();
  }
  onItemDeSelectAdvertiser(item: any) {
    this.onFilter();
  }

  onItemSelectCountry(item: any) {
    this.onFilter();
  }
  onItemDeSelectCountry(item: any) {
    this.onFilter();
  }

  onSelectAllType(items: any) {}
  onDeSelectAllType(items: any) {}

  
  onSelectAllDevice(items: any) {}
  onSelectAllAdvertiser(items: any) {}
  onSelectAllCountry(items: any) {}
  sort(event){}
}
